var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoulder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.43",
    style: {
      enableBackground: "new 0 0 122.88 122.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.65,90.73c2.4,0,4.35,1.95,4.35,4.35c0,2.4-1.95,4.35-4.35,4.35c-2.4,0-4.35-1.95-4.35-4.35 C84.3,92.68,86.25,90.73,88.65,90.73L88.65,90.73z M109.14,122.05L93,121.5v0.01h-0.35v-0.01c-11.54,0-19.42,0-29.54-8.19 c-3.24-2.62-6.21-5.81-8.93-9.51c-0.55-0.76-1.1-1.53-1.63-2.33c0.04,2.54,0.1,5.07,0.17,7.61c0.11,4.28,0.22,9.8,0.22,13.35 l-6.96,0c0-4.47-0.09-9.44-0.19-13.19c-0.21-8.16-0.41-16.31,0.2-24.4c0.25-3.26-0.14-5.6-1.11-7.09c-0.81-1.24-2.19-1.97-4.1-2.23 l0.92-6.88c3.99,0.55,7.02,2.29,9,5.34c1.82,2.8,2.59,6.57,2.22,11.39c-0.07,0.98-0.14,1.96-0.19,2.95l0.32-0.15 c2.02,4.29,4.26,8.16,6.74,11.53c2.37,3.23,4.93,5.98,7.68,8.21c8.24,6.67,15.12,6.67,25.19,6.66v-0.01l0.35,0v0.01 c0.04,0,0.07,0,0.11,0l16.25,0.56L109.14,122.05L109.14,122.05L109.14,122.05z M122.56,0c0.97,6.75-0.27,12.23-3.79,16.41 c-3.41,4.04-8.82,6.61-16.31,7.68c-6.3,0.9-12.86,1.54-19.5,2.19c-6.9,0.68-13.89,1.36-21.03,2.41c-0.19,0.03-0.37,0.04-0.56,0.04 c-17.23,0.79-33.02,1.55-42.7,7.82c-9.24,5.99-13.28,17.7-8.21,40.81l3.71,11.13c0.36,1.1,0.15,2.24-0.48,3.11l0,0 c-2.86,3.97-4.9,8.31-5.95,13.12c-1.05,4.84-1.09,11.78,0.06,17.71H0.99c-1.35-6.9-1.28-13.44-0.04-19.18 c1.12-5.17,3.21-9.88,6.1-14.23l-3.19-9.56c-0.05-0.15-0.1-0.3-0.13-0.45C-2.16,52.28,3.16,38.33,14.9,30.72 c11.25-7.29,27.93-8.11,46.14-8.94c7-1.02,14.16-1.72,21.24-2.42c6.47-0.64,12.86-1.26,19.21-2.17c5.73-0.82,9.71-2.58,11.98-5.28 c2.16-2.57,2.89-6.22,2.21-10.94L122.56,0L122.56,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoulder);
export default __webpack_public_path__ + "static/media/shoulder.d1f935607b4ac4be5d64b6440c3901df.svg";
export { ForwardRef as ReactComponent };